module.exports = __webpack_public_path__ + "img/less-than-equal.e86322dd.svg";